export const APP_ID = 'software.reports.velocity';

export const SLA_FAILURE_REASON_CRITICAL_DATA_FAILED = 'critical-data-failed-unknown-reason';
export const SLA_FAILURE_REASON_REDUX_ERROR = 'redux-exception-reason';
export const SLA_EXPERIENCE = 'viewVelocity';
export const SLA_LOCATION = 'ng-velocity-report';
